import React,{useState} from "react";
import axios from "axios";
import WeatherForecast from "./WeatherForecast";
import WeatherInfo from "./WeatherInfo";
import "./Weather.css";

export default function Weather(props){
const[weatherData, setWeatherData] = useState({ready:false});
const[city,setCity]=useState(props.defaultCity);

function handleResponse(response){
setWeatherData({
    ready:true,
    temperature:response.data.main.temp,
    humidity:response.data.main.humidity,
    date:new Date(response.data.dt*1000),
    description:response.data.weather[0].description,
    icon:response.data.weather[0].icon,
    wind:response.data.wind.speed,
    city:response.data.name
});
    }
    
    function handleSubmit(event){
     event.preventDefault();
     searchCity();
    

    }

    function handleCityChange(event){
        setCity(event.target.value);

    }

function searchCity(){
  const apiKey="5e39f9d1a00339cac657e6d5e124e87d";
  let apiUrl=`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
axios.get(apiUrl).then(handleResponse);

    }

    
   if (weatherData.ready){

    return(
        <div className="Weather">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-9">                    
                <input type="search" placeholder="Type a city..." className="form-control" autoFocus="on" onChange={handleCityChange}/>
                </div>
                <div className="col-3">
                <input type="submit" value="Search" className="btn btn-primary w-100"/>                
                </div>
                </div>
            </form>
            <WeatherInfo data={weatherData} />
            <WeatherForecast city={weatherData.city}/>
            
        </div>
    );}
    else{
        searchCity();
        
    return "Loading.....";
    }
}